const { COLORS } = require("../colors");
const { BASE } = require("./base");

const ORANGE_THEME = {
  ...BASE,
  primary: COLORS.orange["700"],
  primaryDarker: COLORS.orange.brown,
  componentBackground: COLORS.peach["25"],
  componentBackgroundDarker: COLORS.peach["400"],
};

module.exports = {
  ORANGE_THEME,
};
